import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, Container, Text } from "@jds/core";

export default function SubSettingsHeader(props) {
  const { heading } = props;
  const navigate = useNavigate();
  return (
    <Container gap={12} verticalAlign="center">
      <Button icon="IcBack" kind="tertiary" onClick={() => navigate(-1)} />
      <Text text={heading || "Sub settings header"} appearance="heading_s" />
    </Container>
  );
}
